module.exports = __webpack_public_path__ + "static/img/planta.3e6849c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/esquema/planta.jpg
// module id = GRSW
// module chunks = 0